import { createPopupFactory } from './create-popup-factory'
import { createRouterFactory } from './create-router-factory'
import { createToastFactory } from './create-toast-factory'

export * from './create-popup-factory'
export * from './create-router-factory'
export * from './create-toast-factory'

/**
 * When you add a new popup, consider a problem that they rendered by global provider
 * You might face with a problem that your sidebar could be visible on the page where it shouldn't be,
 * So you might need to add a condition (or useEffect on unmounting) to hide it when it's unnecessary
 */
export const popupFactory = createPopupFactory()

/**
 * Router factory for typed navigation and links.
 * Use routerFactory.getPathString({ path, params }) for paths
 * and routerFactory.useRouter().navigate(path, params) / .Navigate for navigation.
 */
export const routerFactory = createRouterFactory()

/**
 * Toast factory for displaying toast notifications
 * Use toastFactory.success() or toastFactory.error() to show toasts
 */
export const toastFactory = createToastFactory()
